import _remove from "lodash/remove";
import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { FetchStatus } from "../../../globalConsts";
import { SystemNotification } from "../../../globalTypes";
import {
  errorReceiveAllNotifications,
  errorRequestSystemNotifications,
  receiveAllNotfications,
  receiveResolveNotification,
  receiveResolveNotifications,
  receiveSystemNotifications,
  requestFetchAllNotifications,
  requestSystemNotifications,
  resetNotificationsSlice,
  resolveNotifications,
} from "../actionCreators";

const { Uninitialized, FetchingInitial, Refetching, Fetched, Failed } =
  FetchStatus;

export type State = {
  messages: SystemNotification[];
  fetchStatus: FetchStatus;
};

const initialState: State = {
  messages: [],
  fetchStatus: Uninitialized,
};

const systemNotificationsReducer = reducer(
  initialState,
  on(
    ...union(requestSystemNotifications, requestFetchAllNotifications),
    (state) => {
      const isFirstFetch = state.fetchStatus === Uninitialized;
      state.fetchStatus = isFirstFetch ? FetchingInitial : Refetching;
    }
  ),
  on(receiveAllNotfications, (state, { payload: { notifications } }) => {
    state.messages = notifications.systemNotifications;
    state.fetchStatus = Fetched;
  }),

  on(receiveSystemNotifications, (state, { payload: { notifications } }) => {
    state.messages = [...notifications];
    state.fetchStatus = Fetched;
  }),
  on(
    ...union(errorRequestSystemNotifications, errorReceiveAllNotifications),
    (state) => {
      state.fetchStatus = Failed;
    }
  ),
  on(resolveNotifications, (state, { payload: { notificationIds } }) => {
    notificationIds.forEach((notificationId) =>
      _remove(state.messages, (msg) => msg.notificationId === notificationId)
    );
  }),
  on(
    receiveResolveNotification,
    (state, { payload: { notificationId }, error }) => {
      if (error) return;
      _remove(state.messages, (msg) => msg.notificationId === notificationId);
    }
  ),
  on(
    receiveResolveNotifications,
    (state, { payload: { notificationIds }, error }) => {
      if (error) return;

      _remove(
        state.messages, // I <3 PRETTIER
        (msg) => notificationIds.includes(msg.notificationId)
      );
    }
  ),
  on(resetNotificationsSlice, () => initialState)
);

export default systemNotificationsReducer;
